<div class="header">
	<div class="header__page-name">
		<h1 class="heading heading--main">Outgoing - Mail Servers</h1>
	</div>
	<div class="header__top-nav">
		<app-outgoing-mail-server-header [totalRecord]="totalMailServerCount" (searchValueEmitter)="searchString($event)"></app-outgoing-mail-server-header>
	</div>
</div>
<div class="wrapper--dash-content dash-content">
	<div *ngIf="errorString" class="message message--is-invalid">
		{{errorString}}
	</div>

	<table datatable [dtOptions]="dtOptions" class="row-border hover" id="doctor">
		<thead>
			<tr>
			</tr>
		</thead>
	</table>
</div>